import { render } from "./PageSoumissionBesc.vue?vue&type=template&id=750b246a&scoped=true&ts=true"
import script from "./PageSoumissionBesc.vue?vue&type=script&lang=ts"
export * from "./PageSoumissionBesc.vue?vue&type=script&lang=ts"

import "./PageSoumissionBesc.vue?vue&type=style&index=0&id=750b246a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750b246a"]])

export default __exports__